<template>
  <div class="lead-tracker-wrapper">
    <h2 class="h2-header">Lead-Quellen-Tracker</h2>
    <div class="lead-tracker-inside-wrapper">
      <v-data-table
        class="content-data-table"
        density="compact"
        :headers="headers"
        :items="trackedLeadsOfSource"
        :search="search"
      >
        <template v-slot:item="{ item }">
          <tr class="v-table-row" @click="goToRawLead(item._id)">
            <td>{{ formatDate(item.createdAt) }}</td>
            <td>{{ item.source }}</td>
            <td>{{ item._id }}</td>
          </tr>
        </template>
      </v-data-table>
    </div>
    <v-select density="compact" hide-details="true" variant="outlined" :items="leadSources" item-title="text" item-value="value" v-model="selectedSource" label="Quelle" rounded="lg"></v-select>
    <v-btn
      :loading="loading"
      class="gradient-color-primary"
      rounded="lg"
      @click="getTrackedLeadsBySource"
      >Letzten 100 Leadeingänge</v-btn>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      headers: [
        { key: "createdAt", title: "Angekommen", sortable: true },
        { key: "source", title: "Quelle", sortable: true },
        { key: "_id", title: "RawLeadID", sortable: true },
      ],
      leadSources: [
        { text: "Onepage", value: "onePage" },
        { text: "Funnelcockpit", value: "funnelCockpit" },
        { text: "Heyflow", value: "heyFlow" },
        { text: "Perspective", value: "perspective" },
        { text: "Meetovo", value: "meetovo" },
        { text: "Thrive", value: "thrive" },
        { text: "Typeform", value: "typeForm" },
        { text: "AidaForm", value: "AidaForm" },
        { text: "generic", value: "generic" },
      ],
      selectedSource: null,
    };
  },
  computed: {
    ...mapState("leadTracker", ["loading", "trackedLeadsOfSource"]),
  },
  methods: {
    ...mapActions("leadTracker", ["getLastRawLeadsOfSource"]),
    async getTrackedLeadsBySource() {
      if (!this.selectedSource) {
        return;
      }
      await this.$store.dispatch("leadTracker/getLastRawLeadsOfSource", { sortBySource: this.selectedSource });
    },
    goToRawLead(rawLeadId) {
      this.$store.dispatch("agency/setDialogReturnRoute", this.$route.fullPath);
      this.$router.push({ name: "raw-lead", params: { rawLeadId } });
    },
    formatDate(date) {
      return new Date(date).toLocaleString('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.lead-tracker-wrapper {
  display: flex;
  flex-direction: column;
  padding: 16px;
  gap: 12px;
  border: 1px solid rgb(196, 196, 196);
  border-radius: 12px;
  background-color: white;
}

.lead-tracker-inside-wrapper {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}

.number-text-field {
  max-width: 100px;
}
v-list {
    background-color: #f5f5f5 !important;
}
</style>
